var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn-svg",style:(_vm.activeStyle),attrs:{"disabled":_vm.disabledOrder,"data-cy":"add-to-cart","type":"button"}},_vm.$listeners),[_c('span',{staticClass:"svg"},[_vm._t("default")],2),_vm._v(" "),_c('span',{staticClass:"btn-title"},[_vm._v(_vm._s(_vm.buttonTitle))]),_vm._v(" "),_vm._t("after")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b38b3faa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/buttons/app-button-order.vue
// module id = 989
// module chunks = 0 2